"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const qs_1 = __importDefault(require("qs"));
const API = {
    list: '/api/ac/v2/service/management/webhook/published/list',
    create: '/api/ac/v2/service/management/webhook/published/create',
    update: '/api/ac/v2/service/management/webhook/published/update',
    delete: '/api/ac/v2/service/management/webhook/published/delete',
    logs: '/api/kycc/webhookLog/listRecords',
    redeliveryWebhook: '/api/kycc/webhookLog/redeliveryWebhook',
};
class Webhook {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getListWebhook(clientId, page, limit) {
        const query = {
            page,
            limit,
            clientId,
        };
        const url = `${API.list}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            paging: {
                page,
                limit,
                total: 0,
            },
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody || lodash_1.default.isEmpty(resBody.result)) {
            return data;
        }
        data.result = resBody.result;
        data.paging = resBody.paging;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * /api/ac/webhook/published/create
     * method: POST
     * payload: {"clientId":"an_dev_23_01_b04cd","content_type":"application/json","events":["user.created","review.approved","user.readyToReview"],"name":"An Dev webhook","secret":"123","url":"https://dev.com"}
     * res: {"status":"success","data":{"result":"636369dfa73c4179172cffeb","entities":{"webhook":{"636369dfa73c4179172cffeb":{"service":"62467636340a771c11c6607f","name":"An Dev webhook","events":["user.created","review.approved","user.readyToReview"],"url":"https://dev.com","content_type":"application/json","secret":"123","status":"inactive","_id":"636369dfa73c4179172cffeb","createdAt":"2022-11-03T07:12:32.042Z","updatedAt":"2022-11-03T07:12:32.042Z","__v":0}}}}}
     */
    async createWebhook(clientId, payload) {
        const res = await this._httpClient.post(API.create, {
            clientId,
            ...payload,
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    /**
     * /api/ac/webhook/published/update
     * method: put
     * payload: {"clientId":"an_dev_23_01_b04cd","webhookId":"636369dfa73c4179172cffeb","status":"active","events":["user.created","review.approved","user.readyToReview"]}
     * res: {"status":"success","data":{"result":"636369dfa73c4179172cffeb","entities":{"webhook":{"636369dfa73c4179172cffeb":{"_id":"636369dfa73c4179172cffeb","service":"62467636340a771c11c6607f","name":"An Dev webhook","events":["user.created","review.approved","user.readyToReview"],"url":"https://dev.com","content_type":"application/json","secret":"123","status":"active","createdAt":"2022-11-03T07:12:32.042Z","updatedAt":"2022-11-03T07:14:07.210Z","__v":0}}}}}
     */
    async updateWebhook(clientId, webhookId, payload) {
        const res = await this._httpClient.put(API.update, {
            clientId,
            webhookId,
            ...payload,
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    /**
     * /api/ac/webhook/published/delete
     * method: delete
     * payload: {"clientId":"an_dev_23_01_b04cd","webhookId":"636369dfa73c4179172cffeb"}
     * res: {"status":"success","data":{"result":null,"entities":{}}}
     */
    async deleteWebhook(clientId, webhookId) {
        await this._httpClient.delete(API.delete, {
            data: {
                clientId,
                webhookId,
            },
        });
        return {
            result: null,
            entities: {},
        };
    }
    async getWebhookLog(params) {
        const res = await this._httpClient.post(API.logs, params);
        const page = params.options.skip / params.options.limit;
        const limit = params.options.limit;
        const data = {
            result: null,
            paging: {
                page,
                limit,
                total: 0,
            },
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody || lodash_1.default.isEmpty(resBody.rows)) {
            return data;
        }
        data.result = lodash_1.default.map(resBody.rows, '_id');
        data.paging.total = lodash_1.default.get(resBody, '_meta.total', resBody.rows.length);
        data.entities = {
            webhookLogs: lodash_1.default.keyBy(resBody.rows, '_id'),
        };
        return data;
    }
    /**
     * api: https://qa-mapi.blockpass.org/api/kycc/webhookLog/redeliveryWebhook
     * method: POST
     * body:  "body": "{\"clientId\":\"an_dev_23_01_b04cd\",\"webhookLogId\":\"6375dc2159ea053d4a6ae534\"}",
     * res: empty
     */
    async retryWebhook(clientId, webhookLogId) {
        await this._httpClient.post(API.redeliveryWebhook, {
            clientId,
            webhookLogId,
        });
        return {
            result: null,
            entities: {},
        };
    }
}
exports.default = Webhook;
